import { triplaServer } from 'src/apis/server'

export default {
  getReservations() {
    return triplaServer.get('api/triplabot/v1/user/reservations').then((res) => res.data.data)
  },

  getReservation(id) {
    return triplaServer.get(`api/triplabot/v1/user/reservations/${id}`).then((res) => res.data.data)
  },

  updateReservation(id, payload) {
    return triplaServer
      .put(`api/triplabot/v1/user/reservations/${id}`, {
        reservation: payload
      })
      .then((res) => res.data.data)
  },

  cancelReservation(id) {
    return triplaServer
      .patch(`api/triplabot/v1/user/reservations/${id}/cancel`)
      .then((res) => res.data.data)
  }
}
